export const buildSubscriptionStocksPayload = (
  watchList: Array<{ scripId: string; active?: string }> = [],
  watchListStockMap: Map<string, unknown>
) =>
  watchList.map(({ scripId }) => ({
    stockId: scripId,
    channel: 'channel',
    active: watchListStockMap.has(scripId) ? 'Y' : 'N',
  }));

export type WatchListSortOrder = 'asc' | 'desc';

type SortableWatchListItem = {
  stockName: string;
};

const compareByName = (a: string, b: string) =>
  a.localeCompare(b, undefined, { sensitivity: 'base' });

export const sortWatchList = <T extends SortableWatchListItem>(
  items: T[],
  order: WatchListSortOrder
): T[] => {
  const sorted = [...items];
  return sorted.sort((a, b) =>
    order === 'asc'
      ? compareByName(a.stockName, b.stockName)
      : compareByName(b.stockName, a.stockName)
  );
};
